import { render, staticRenderFns } from "./InterInfoCard.vue?vue&type=template&id=891553c8&scoped=true&"
import script from "./InterInfoCard.vue?vue&type=script&lang=js&"
export * from "./InterInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891553c8",
  null
  
)

export default component.exports